export enum SupportedNumberFormat {
  IntlCompact,
  IntlStandard,
}

const shortFormatter = Intl.NumberFormat('en', { notation: 'compact' });
const longFormatter = Intl.NumberFormat('pl', { notation: 'standard' });

const formatNumberDefaultOpts: Required<NumberFormatOptions> = {
  format: SupportedNumberFormat.IntlStandard,
  zeroReplacement: `0`,
};

export type NumberFormatOptions = {
  format?: SupportedNumberFormat;
  zeroReplacement?: string;
};

export const formatNumber = (value: number, opts?: NumberFormatOptions): string => {
  const { format, zeroReplacement } = {
    ...formatNumberDefaultOpts,
    ...opts,
  };

  if (value === 0) return zeroReplacement;

  switch (format) {
    case SupportedNumberFormat.IntlCompact:
      return shortFormatter.format(value);

    case SupportedNumberFormat.IntlStandard:
      return longFormatter.format(value);

    default:
      return `${value}`;
  }
};
